import {atom} from 'jotai'
import {MerchantDataType} from '../domain'

const merchantData: MerchantDataType = {
  merchantID: '',
  merchantName: '',
  merchantEmail: '',
  isoName: '',
  userID: '',
  isoid: '',
  updateDateAndTime: '',
  name: '',
  surname: '',
  email: '',
  phone: '',
  title: '',
  titleID: '',
  token: null,
}

export const merchantDataAtom = atom<MerchantDataType>(merchantData)
